import MapMarker from '../../../../maps/marker';

const HOVER_TIMEOUT_MS = 150;

class FinderMapMarkerComponent extends React.Component {
    constructor(props) {
        super(props);
        this.mapMarker = null;
        this.mapMarkerObserveFunction = null;
        this.hoverTimeout = null;
    }

    componentDidMount() {
        this._createMapMarker();

        this.mapMarkerObserveFunction = this._observeMapMarker.bind(this);
        this.mapMarker.observe(this.mapMarkerObserveFunction);
    }

    _observeMapMarker(eventType) {
        switch (eventType) {
            case 'mouseover':
                this._clearHoverTimeout();
                this._onStationHover();
                break;
            case 'mouseout':
                this._onStationHoverEnd();
                break;
            case 'gmp-click':
                if (this.props.inDetailMode) {
                    this.props.onListModeClick();
                } else {
                    this.props.onDetailModeClick(this.props.data.id);
                }
                break;
        }
    }

    _clearHoverTimeout() {
        if (this.hoverTimeout) {
            clearTimeout(this.hoverTimeout);
            this.hoverTimeout = null;
            return true;
        }

        return false;
    }

    _onStationHoverEnd() {
        if (!this._clearHoverTimeout()) {
            this.props.onStationHoverEnd();
        }
    }

    _onStationHover() {
        this.hoverTimeout = setTimeout(() => {
            this.props.onStationHover(this.props.data.id, {markerHovered: true});
            this.hoverTimeout = null;
        }, HOVER_TIMEOUT_MS);
    }

    componentWillUnmount() {
        this._destroyMapMarker();
    }

    componentDidUpdate(prevProps) {
        if (
            (prevProps.inDetailMode !== this.props.inDetailMode) ||
            (prevProps.isHovered !== this.props.isHovered)
        ) {
            this._setIcon();

            if (prevProps.inDetailMode !== this.props.inDetailMode) {
                if (this.props.inDetailMode) {
                    this.props.map.setZoom(16);
                } else {
                    this.props.map.setZoom(11);
                }
            }
        }

        if (prevProps.data.totalPrice !== this.props.data.totalPrice) {
            this.mapMarker.unsubscribe(this.mapMarkerObserveFunction);
            this._destroyMapMarker();
            this._createMapMarker();

            this.mapMarkerObserveFunction = this._observeMapMarker.bind(this);
            this.mapMarker.observe(this.mapMarkerObserveFunction);
        }
    }

    render() {
        var stationData = this.props.data;
        return (
            <span data-lat={stationData.latitude}
                  data-lng={stationData.longitude}
                  data-id={stationData.id}
                  data-total-price={stationData.totalPrice}
                  data-name={stationData.name}
                  data-is-selected={this.props.isSelected}
                  data-in-detail-mode={this.props.inDetailMode}
                  style={{display: 'none'}}
            />
        );
    }

    _createMapMarker() {
        var stationData = this.props.data;
        var price = this.props.totalCart;
        if (!TYROOLA.globals.fsFinderShowTotalCart) {
            price = stationData.totalPrice;
        }

        var mapMarker = new MapMarker(
            this.props.gMap,
            stationData.latitude,
            stationData.longitude,
            stationData.id,
            price,
            stationData.name.replace(/ /g, '&nbsp;'),
            stationData.isMobileFitter && stationData.isCoverageAreaDefined,
            stationData.isMarketplaceSeller === true || stationData.isMarketplaceSeller === 'true',
            stationData.hasOwnProperty('productStock') && true === stationData.productStock.isMpsProduct,
            stationData
        );
        mapMarker.init();

        this.mapMarker = mapMarker;
    }

    _destroyMapMarker() {
        if (this.mapMarker) {
            this.mapMarker.destroy();
        }
    }

    _setIcon() {
        this.mapMarker.setLabelClasses({
            inDetailMode: this.props.inDetailMode,
            isHovered: this.props.isHovered
        });
    }
}

export default FinderMapMarkerComponent;
